<template>
  <!-- Projects Modal -->
  <div class="modal fade" id="mobileAppModal" tabindex="-1" aria-labelledby="mobileAppModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="mobileAppModalLabel">行動應用程式開發作品集</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- DVR/NVR App -->
          <div class="project-section mb-5">
            <div class="row align-items-center">
              <div class="col-md-6">
                <h4>監控系統遠端連線 App</h4>
                <p class="text-muted">DVR/NVR 即時監控與回放系統</p>
                <div class="mb-4">
                  <h6 class="fw-bold"><i class="bi bi-stars"></i> 主要功能</h6>
                  <div class="d-flex align-items-center justify-content-center">
                    <ul class="list-unstyled text-start">
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>即時影像串流監看</li>
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>多路影像同時觀看</li>
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>歷史影像回放功能</li>
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>遠端 PTZ 攝影機控制</li>
                    </ul>
                  </div>
                  <h6 class="fw-bold mt-3"><i class="bi bi-code-square"></i> 技術重點</h6>
                  <div class="d-flex flex-wrap gap-2 justify-content-center">
                    <span class="badge bg-primary">RTSP 串流</span>
                    <span class="badge bg-primary">H.264/H.265</span>
                    <span class="badge bg-primary">多執行緒</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <img src="../../assets/images/project-banner/dvr-nvr.jpg" class="img-fluid rounded shadow" alt="DVR App 截圖">
              </div>
            </div>
          </div>

          <hr>

          <!-- BLE 額溫槍 App -->
          <div class="project-section mb-5">
            <div class="row align-items-center">
              <div class="col-md-6">
                <h4>智慧型額溫槍同步 App</h4>
                <p class="text-muted">藍牙低功耗醫療裝置整合方案</p>
                <div class="mb-4">
                  <h6 class="fw-bold"><i class="bi bi-stars"></i> 主要功能</h6>
                  <div class="d-flex align-items-center justify-content-center">
                    <ul class="list-unstyled text-start">
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>BLE 裝置自動配對</li>
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>掃 BarCode 登錄對應人員</li>
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>即時溫度數據同步</li>
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>測量紀錄儲存</li>
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>異常體溫警示通知</li>
                    </ul>
                  </div>
                  <h6 class="fw-bold mt-3"><i class="bi bi-code-square"></i> 技術重點</h6>
                  <div class="d-flex flex-wrap gap-2 justify-content-center">
                    <span class="badge bg-primary">BLE Protocol</span>
                    <span class="badge bg-primary">即時數據處理</span>
                    <span class="badge bg-primary">本地資料庫</span>
                    <span class="badge bg-primary">數據視覺化</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <img src="../../assets/images/project-banner/thermometer-app.jpg" class="img-fluid rounded shadow" alt="額溫槍 App 截圖">
              </div>
            </div>
          </div>

          <hr>

          <!-- 揪團運動 App -->
          <div class="project-section mb-5">
            <div class="row align-items-center">
              <div class="col-md-6">
                <h4>揪團運動社交 App</h4>
                <p class="text-muted">運動社群互動平台</p>
                <div class="mb-4">
                  <h6 class="fw-bold"><i class="bi bi-stars"></i> 主要功能</h6>
                  <div class="d-flex align-items-center justify-content-center">
                    <ul class="list-unstyled text-start">
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>活動建立與報名系統</li>
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>即時聊天室功能</li>
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>運動場地資訊整合</li>
                      <li><i class="bi bi-check-circle-fill text-success me-2"></i>個人運動記錄追蹤</li>
                    </ul>
                  </div>
                  <h6 class="fw-bold mt-3"><i class="bi bi-code-square"></i> 技術重點</h6>
                  <div class="d-flex flex-wrap gap-2 justify-content-center">
                    <span class="badge bg-primary">Firebase</span>
                    <span class="badge bg-primary">會員系統</span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <img src="../../assets/images/project-banner/sports-app.jpg" class="img-fluid rounded shadow" alt="揪團運動 App 截圖">
              </div>
            </div>
          </div>

          <!-- 技術總覽 -->
          <div class="bg-light p-4 rounded">
            <h5 class="text-center mb-4"><i class="bi bi-gear-fill"></i> 技術總覽</h5>
            <div class="row g-4">
              <div class="col-md">
                <h6 class="fw-bold"><i class="bi bi-code-slash"></i> 開發環境</h6>
                <div class="d-flex flex-wrap gap-2 justify-content-center">
                  <span class="badge bg-secondary">Android/iOS Dev</span>
                  <span class="badge bg-secondary">Java</span>
                  <span class="badge bg-secondary">Kotlin</span>
                  <span class="badge bg-secondary">Objective-C</span>
                  <span class="badge bg-secondary">Flutter</span>
                  <span class="badge bg-secondary">Git</span>
                </div>
              </div>
              <div class="col-md">
                <h6 class="fw-bold"><i class="bi bi-gear"></i> 整合服務</h6>
                <div class="d-flex flex-wrap gap-2 justify-content-center">
                  <span class="badge bg-secondary">RESTful API</span>
                  <span class="badge bg-secondary">Firebase</span>
                  <span class="badge bg-secondary">Maps SDK</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">關閉</button>
        </div>
      </div>
    </div>
  </div>
</template>
